<template>

  <div class="w-full flex items-center justify-center px-4" style="height: calc(100vh - 60px)">
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm mx-auto w-full max-w-[360px]">
      <div class="flex flex-col gap-y-1.5 p-4 lg:p-6 lg:pb-0">
        <h1 class="font-bold tracking-tight text-2xl md:text-3xl">Sign in to your account</h1>
      </div>
      <div class="p-4 lg:p-6 pt-0">

        <div class="mb-6">
          <button 
          @click="signInWithGoogle"
          class="relative inline-flex h-10 w-auto min-w-min max-w-[400px] select-none appearance-none items-center overflow-hidden whitespace-nowrap rounded-full border border-zinc-950/10 bg-white px-3 align-middle text-sm tracking-[0.25px] text-[#1f1f1f] outline-none"
          >
            <div class="relative flex h-full w-full flex-nowrap items-center justify-between">
              <div class="mr-3 h-5 w-5">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                  <path fill="none" d="M0 0h48v48H0z"></path>
                </svg>
              </div>
              <span class="flex-grow overflow-hidden text-ellipsis align-top font-medium">Sign in with Google</span>
              <span class="hidden">Sign in with Google</span>
            </div>
          </button>
        </div>

        <div class="mb-6 text-black font-semibold text-sm">
          Or sign in with your email address
        </div>

        <form 
        v-if="!forgot"
        @submit.prevent="handleStandardSignin" 
        class="grid gap-4"
        >
          <div class="grid gap-2">
            <input
            :disabled="loading"
            class="w-full rounded-lg border border-zinc-950/10 px-3.5 py-2.5 text-zinc-950 sm:text-sm disabled:opacity-50"
            v-model="email"
            id="email"
            type="email"
            autocomplete="email"
            autocapitalize="off"
            placeholder="email@example.com"
            >
          </div>
          <div class="grid gap-2">
            <input 
            :disabled="loading"
            class="w-full rounded-lg border border-zinc-950/10 px-3.5 py-2.5 text-zinc-950 sm:text-sm disabled:opacity-50"
            v-model="password"
            id="password"
            type="password"
            autocapitalize="off"
            autocomplete="current-password"
            placeholder="••••••••••"
            >
          </div>
          <div v-if="formError" class="bg-red text-white rounded-lg p-4 text-sm">
            {{ formError }}
          </div>
          <button 
          :disabled="loading"
          class="w-full nba font-bold leading-none block rounded-[20px] border uppercase border-yellow bg-yellow text-black px-3 pt-2.5 pb-2.5 text-base outline-none disabled:opacity-50"
          type="submit"
          >
            Sign in
          </button>
          <div class="flex items-center">
            <span></span>
            <!-- <label 
            for="password" 
            class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Password
            </label> -->
            <span
            @click="forgot = true"
            class="ml-auto inline-block text-sm underline cursor-pointer"
            >
              Forgot your password?
            </span>
          </div>
        </form>

        <div v-if="forgot && !otpSent" class="grid gap-4">
          <div class="grid gap-2">
            <!-- <label 
            for="email" 
            class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Email
            </label> -->
            <input
            class="w-full rounded-lg border border-zinc-950/10 px-3.5 py-2.5 text-zinc-950 sm:text-sm"
            v-model="email"
            id="email"
            type="email"
            autocomplete="email"
            autocapitalize="off"
            placeholder="email@example.com"
            :disabled="otpSent || loading"
            >
          </div>
          <button 
          @click="getMagicLink"
          :disabled="otpSent || loading"
          class="btn btn--md btn--yellow w-full disabled:opacity-50"
          >
            Get login link
          </button>
          <div class="flex justify-between text-sm text-muted-foreground">
            <span></span>
            <span @click="forgot = false" class="cursor-pointer underline">Go back to sign in</span>
          </div>
        </div>
        <div v-if="forgot && otpSent" class="grid gap-4">
          <div class="text-sm text-muted-foreground">
            Your login link has been sent to your email. Please check your inbox and junk mail.
          </div>
        </div>
        <!-- <div class="mt-4 text-center text-sm">
          Don't have an account? 
          <NuxtLink to="/join" class="underline">Sign up</NuxtLink>
        </div> -->
      </div>
    </div>
  </div>

</template>

<script setup>
const user = useSupabaseUser()
const supabase = useSupabaseClient()
const messageStore = useMessageStore()
const userStore = useUserStore()
const config = useRuntimeConfig()
const route = useRoute()
const router = useRouter()
const { $seo } = useNuxtApp()

const loading = ref(false)
const formError = ref(null)
const email = ref('')
const password = ref('')
const otp = ref('')

const otpSent = ref(false)

const forgot = ref(false)

const getMagicLink = async () => {
  const { data, error } = await supabase.auth.signInWithOtp({
    email: email.value,
    options: {
      shouldCreateUser: false
    }
  })
  if (!error) {
    otpSent.value = true
    messageStore.message(`Please check your email for the link to log in.`, 10, 'success')
  } else {
    messageStore.message(`There has been an error attempting to log in. Please try again later.`)
  }
}

const signInWithGoogle = async () => {
  loading.value = true
  formError.value = null
  const { data: googleLogin, error: googleLoginError } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: `${config.public.baseUrl}/play`,
    }
  })
  if (googleLoginError) {
    formError.value = 'Error signing in with Google. Please try again.'
    console.error('Error signing in with Google:', error.message)
  }
  loading.value = false
}

const verifyOtp = async () => {
  const { data: otpLogin, error: otpLoginError } = await supabase.auth.verifyOtp({
    email: email.value,
    token: otp.value,
    type: 'email',
  })
  if (!otpLoginError) {
    if (otpLogin.user) {
      messageStore.message(`Welcome!`, 5, 'success')
      userStore.signIn(otpLogin.user.id)
    }
  }
}

const handleStandardSignin = async () => {
  if (!email.value || !password.value) {
    formError.value = 'Please enter your email and password'
    return
  }
  try {
    loading.value = true
    formError.value = null
    const { data: signin, error: signinError } = await supabase.auth.signInWithPassword({
      email: email.value,
      password: password.value
    })
    if (signinError) {
      if (signinError.message.includes('Invalid login')) {
        formError.value = 'Invalid login. Please try again.'
        return
      } else if (signinError.message.includes('Email not confirmed')) {
        formError.value = `Your email address has not been confirmed. Please check your email (and spam folder) for the confirmation link.`
        return
      }
      formError.value = signinError
      return
    }
    if (signin.user) {
      messageStore.message(`Welcome!`, 5, 'success')
      userStore.signIn(signin.user.id)
    }
  } catch (error) {
    formError.value = error
  } finally {
    loading.value = false
  }
}

const seo = computed(() => {
  return $seo({
    meta_title: 'Log in to Drum Rudiments – Continue Your Practice', 
    meta_description: 'Welcome back! Log in to your Drum Rudiments account to continue your practice session and track your drumming progress.', 
    meta_image: null
  }, route.fullPath)
})

useHead(seo)

watchEffect(async () => {
  if (user.value) {
    reloadNuxtApp({
      path: "/play",
      ttl: 100
    })
  }
})
</script>